/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_asciiToArray.js
// module id = 876
// module chunks = 0 1 2 3 4 5 6 7 8